(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4777],{

/***/ 44777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(305);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hiredigital_lib_helpers_date__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98608);
/* harmony import */ var _Author_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60948);
/* harmony import */ var _Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Author_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var Author = function(param) {
    var author = param.author, fallbackAuthor = param.fallbackAuthor, date = param.date;
    var ref, ref1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: (author === null || author === void 0 ? void 0 : (ref = author.profile) === null || ref === void 0 ? void 0 : ref.picture) || "/img/avatar.webp",
                className: (_Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default().picture),
                alt: (author === null || author === void 0 ? void 0 : author.name) || "author image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default().details),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                        children: (author === null || author === void 0 ? void 0 : author.name) || (fallbackAuthor === null || fallbackAuthor === void 0 ? void 0 : fallbackAuthor.name)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_Author_module_scss__WEBPACK_IMPORTED_MODULE_4___default().description),
                        children: (author === null || author === void 0 ? void 0 : (ref1 = author.profile) === null || ref1 === void 0 ? void 0 : ref1.headline) || date && (0,_hiredigital_lib_helpers_date__WEBPACK_IMPORTED_MODULE_3__/* .toReadableDate */ .i0)(date)
                    })
                ]
            })
        ]
    });
};
Author.propTypes = {
    author: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object),
    fallbackAuthor: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().object)
};
/* harmony default export */ __webpack_exports__["default"] = (Author);


/***/ }),

/***/ 98608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g9": function() { return /* binding */ getDuration; },
/* harmony export */   "i0": function() { return /* binding */ toReadableDate; },
/* harmony export */   "i3": function() { return /* binding */ getDates; }
/* harmony export */ });
/* unused harmony exports timeFormatter, callTimeFormatter, callDayFormatter, toReadableDateTime, toReadableMedDateTime, toReadableShortDateTime, toScheduledCallDateTime, getDateFromMonthYear, isDateValid, daysOfWeek, hoursInDay, months, days, monthNumToName, secondsToDuration, durationToSeconds, addDurationToTime, checkDateValidity, convertToDay, convertToHour, hoursToDaysMonthsYears, convertToDuration, millisecondsToSeconds, secsToHours, minsToHours, daysToHours, monthsToHours, yearsToHours, toDurationString, durationToHours, addZero, durationToTimestamps */
/* harmony import */ var date_fns_differenceInCalendarMonths__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7095);
/* harmony import */ var date_fns_tz_format__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4569);
/* harmony import */ var date_fns_tz_format__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(date_fns_tz_format__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var date_fns_subDays__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8604);


// import formatDistanceToNow from 'date-fns/formatDistanceToNow';








var timeFormatter = function(date) {
    return format(new Date(date), "h:mm a");
};
var callTimeFormatter = function(date, offset) {
    var zonedDate = utcToZonedTime(new Date(date), offset); // In June 10am UTC is 6am in New York (-04:00)
    return format(zonedDate, "h:mm a", {
        timeZone: offset
    });
};
var callDayFormatter = function(date, offset) {
    var zonedDate = utcToZonedTime(new Date(date), offset); // In June 10am UTC is 6am in New York (-04:00)
    return format(zonedDate, "EEE, d MMM, yyyy", {
        timeZone: offset
    });
};
var toReadableDate = function(date) {
    var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "d MMM yyyy";
    return date_fns_tz_format__WEBPACK_IMPORTED_MODULE_0___default()(new Date(date), f);
};
var toReadableDateTime = function(date) {
    return format(new Date(date), "d MMM yyyy h:mm:ss a");
};
var toReadableMedDateTime = function(date) {
    return format(new Date(date), "d MMM yy h:mm a");
};
var toReadableShortDateTime = function(date) {
    return format(new Date(date), "d MMM h:mm a");
};
var toScheduledCallDateTime = function(date) {
    var d = new Date(date);
    return "".concat(format(d, "h:mm a"), " on ").concat(format(d, "dd MMM yyyy"));
};
var getDateFromMonthYear = function(m, y) {
    return new Date(y, m, 0, 0, 0, 0, 0);
};
var isDateValid = function(month, year) {
    var isValid = true;
    var error = null;
    if (year < 1900 || year > 2030) {
        isValid = true;
        error = "Enter a valid year";
    } else if (month > 12) {
        isValid = true;
        error = "Enter a valid month";
    }
    return {
        isValid: isValid,
        error: error
    };
};
var daysOfWeek = [
    {
        short: "Su",
        long: "Sunday"
    },
    {
        short: "Mo",
        long: "Monday"
    },
    {
        short: "Tu",
        long: "Tuesday"
    },
    {
        short: "We",
        long: "Wednesday"
    },
    {
        short: "Th",
        long: "Thursday"
    },
    {
        short: "Fr",
        long: "Friday"
    },
    {
        short: "Sa",
        long: "Saturday"
    }, 
];
var hoursInDay = [
    {
        value: "12 AM",
        extended: true
    },
    {
        value: "1 AM",
        extended: true
    },
    {
        value: "2 AM",
        extended: true
    },
    {
        value: "3 AM",
        extended: true
    },
    {
        value: "4 AM",
        extended: true
    },
    {
        value: "5 AM",
        extended: true
    },
    {
        value: "6 AM",
        extended: true
    },
    {
        value: "7 AM",
        extended: true
    },
    {
        value: "8 AM",
        extended: false
    },
    {
        value: "9 AM",
        extended: false
    },
    {
        value: "10 AM",
        extended: false
    },
    {
        value: "11 AM",
        extended: false
    },
    {
        value: "12 PM",
        extended: false
    },
    {
        value: "1 PM",
        extended: false
    },
    {
        value: "2 PM",
        extended: false
    },
    {
        value: "3 PM",
        extended: false
    },
    {
        value: "4 PM",
        extended: false
    },
    {
        value: "5 PM",
        extended: false
    },
    {
        value: "6 PM",
        extended: false
    },
    {
        value: "7 PM",
        extended: true
    },
    {
        value: "8 PM",
        extended: true
    },
    {
        value: "9 PM",
        extended: true
    },
    {
        value: "10 PM",
        extended: true
    },
    {
        value: "11 PM",
        extended: true
    }, 
];
var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December", 
];
var days = (/* unused pure expression or super */ null && ([
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
]));
var getDuration = function(startMonth, startYear, endMonth, endYear) {
    if (startMonth) {
        var ret, endDate;
        var startDate = (0,date_fns_subDays__WEBPACK_IMPORTED_MODULE_1__["default"])(new Date(startYear, startMonth - 1), 1);
        if (endMonth && endYear) {
            endDate = new Date(endYear, endMonth - 1);
        } else {
            endDate = new Date();
        }
        var diff = (0,date_fns_differenceInCalendarMonths__WEBPACK_IMPORTED_MODULE_2__["default"])(endDate, startDate);
        var years = Math.floor(diff / 12);
        var months = diff % 12;
        if (years || months) {
            ret = " (" + (years ? years + (years === 1 ? " year" : " years") : "") + (years === 0 ? "" : months ? " " : "") + (months ? String(months) + (months === 1 ? " month" : " months") : "") + ")";
        }
        return ret || "";
    }
    return "";
};
var monthNumToName = function(monthnum) {
    return months[monthnum - 1] || "";
};
var getDates = function(startMonth, startYear, endMonth, endYear) {
    if (!startMonth && !startYear) {
        return "";
    }
    var start = "".concat(monthNumToName(startMonth), " ").concat(startYear);
    var end = endMonth ? "".concat(monthNumToName(endMonth), " ").concat(endYear) : "Present";
    return "".concat(start, " - ").concat(end);
};
// ie. 120 -> 00:02:00
var secondsToDuration = function(seconds) {
    var h = String(Math.floor(seconds / 3600));
    var m = String(Math.floor(seconds % 3600 / 60));
    var s = String(Math.floor(seconds % 3600 % 60));
    h = h.length === 1 ? "0" + h : h;
    m = m.length === 1 ? "0" + m : m;
    s = s.length === 1 ? "0" + s : s;
    return h + ":" + m + ":" + s;
};
// ie. 11:11:11 to 40271
var durationToSeconds = function(duration) {
    var d = String(duration) || "";
    var ref = _sliced_to_array(d.split(":"), 3), tmp = ref[0], h = tmp === void 0 ? 0 : tmp, tmp1 = ref[1], m = tmp1 === void 0 ? 0 : tmp1, tmp2 = ref[2], s = tmp2 === void 0 ? 0 : tmp2;
    var seconds = parseInt(h) * 60 * 60 + parseInt(m) * 60 + parseInt(s);
    return seconds;
};
var addDurationToTime = function(duration, time) {
    var seconds = durationToSeconds(duration);
    var end = add(new Date(time), {
        seconds: seconds
    });
    return end;
};
var checkDateValidity = function(date) {
    return !isAfter(new Date("01/01/1900"), date);
};
var convertToDay = function(dayIndex) {
    var dayFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "EEEE";
    return format(setDay(new Date(), dayIndex), dayFormat);
};
var convertToHour = function(hour) {
    var hourFormat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "h a";
    return format(setHours(new Date(), hour), hourFormat);
};
var hoursToDaysMonthsYears = function(h) {
    var value = h;
    var units = {
        years: 24 * 30.5 * 12,
        months: 24 * 30.5,
        days: 24
    };
    var result = {};
    for(var u in units){
        var p = Math.floor(value / units[u]);
        result[u] = p > 0 ? p : 0;
        value = value % units[u];
    }
    return result;
};
var convertToDuration = function(v) {
    if (!v) return {};
    var ref = _sliced_to_array(v.split(":"), 3), h = ref[0], minutes = ref[1], s = ref[2];
    var ref1 = _sliced_to_array(s.includes(".") ? parseFloat(s).toFixed(3).split(".") : [
        s,
        0
    ], 2), seconds = ref1[0], milliseconds = ref1[1];
    var ref2 = _sliced_to_array(h.includes(" ") ? h.split(" ") : [
        0,
        h
    ], 2), days = ref2[0], hours = ref2[1];
    var convertToInt = function(v) {
        return parseInt(v || 0);
    };
    milliseconds = convertToInt(milliseconds);
    seconds = convertToInt(seconds);
    minutes = convertToInt(minutes);
    hours = convertToInt(hours);
    days = convertToInt(days);
    var values = {
        milliseconds: milliseconds,
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days
    };
    var units = {
        milliseconds: 1000,
        seconds: 60,
        minutes: 60,
        hours: 24
    };
    var value = {};
    var nextValue = 0;
    for(var u in units){
        var rem = values[u] % units[u];
        value[u] = rem + nextValue;
        nextValue = Math.floor(values[u] / units[u]);
    }
    var dmy = hoursToDaysMonthsYears(value.hours + days * 24);
    return _object_spread({}, value, dmy);
};
var millisecondsToSeconds = function(ms) {
    if (!ms) return 0;
    return ms / 1000;
};
var secsToHours = function(s) {
    if (!s) return 0;
    return s / 3600;
};
var minsToHours = function(m) {
    if (!m) return 0;
    return m / 60;
};
var daysToHours = function(d) {
    if (!d) return 0;
    return d * 24;
};
var monthsToHours = function(mo) {
    if (!mo) return 0;
    return mo * 30.5 * 24;
};
var yearsToHours = function(y) {
    if (!y) return 0;
    return y * 30.5 * 24 * 12;
};
var toDurationString = function(duration) {
    ;
    var hours = String(Math.floor(duration / 3600));
    var mins = String(Math.floor(duration % 3600 / 60));
    var secs = String(Math.floor(duration % 3600 % 60));
    hours = hours.length === 1 ? "0" + hours : hours;
    mins = mins.length === 1 ? "0" + mins : mins;
    secs = secs.length === 1 ? "0" + secs : secs;
    return hours + ":" + mins + ":" + secs;
};
var durationToHours = function(duration) {
    var total = secsToHours(duration.seconds + millisecondsToSeconds(duration.milliseconds)) + minsToHours(duration.minutes) + duration.hours + daysToHours(duration.days) + monthsToHours(duration.months) + yearsToHours(duration.years);
    return parseFloat(total);
};
var addZero = function(v) {
    return "".concat(v).length === 1 ? "0".concat(v).slice(-2) : v;
};
var durationToTimestamps = function(duration) {
    var h = daysToHours(duration.days) + monthsToHours(duration.months) + yearsToHours(duration.years) + duration.hours;
    return "".concat(addZero(h) || "00", ":").concat(addZero(duration.minutes) || "00", ":").concat(addZero(duration.seconds) || "00");
};


/***/ }),

/***/ 60948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Author_container__cET0l","details":"Author_details__SCdCg","title":"Author_title__AgMMu","description":"Author_description__8If7K","picture":"Author_picture__meTMt"};

/***/ })

}]);